import {
  // SEARCH_FUND_INIT,
  // SEARCH_FUND_SUCCESS,
  // SEARCH_FUND_FAILED,
  GET_REGION_INIT,
  GET_REGION_SUCCESS,
  GET_REGION_FAILED,
  FOLLOW_FUND_INIT,
  FOLLOW_FUND_SUCCESS,
  FOLLOW_FUND_FAILED,
  GET_STRATEGY_INIT,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_FAILED,
  GET_SUBSPECIALTY_INIT,
  GET_SUBSPECIALTY_SUCCESS,
  GET_SUBSPECIALTY_FAILED,
  CREATE_RECOMMENDFUND_INIT,
  CREATE_RECOMMENDFUND_SUCCESS,
  CREATE_RECOMMENDFUND_FAILED,
  SEARCH_HEDGEFUND_INIT,
  SEARCH_HEDGEFUND_SUCCESS,
  SEARCH_HEDGEFUND_FAILED,
} from "./constants";
const initialState = {
  hedgefunds: [],
  loading: false,
  rmfundLoading : false ,
  total: 0,
  regions: [],
  companyStrategyData: [],
  subSpecialties : []
};

export default function SearchHedgeFundStore(state = initialState, action) {
  switch (action.type) {
    case SEARCH_HEDGEFUND_INIT:
      return { ...state, loading: true };
    case SEARCH_HEDGEFUND_SUCCESS:
      return {
        ...state,
        loading: false,
        total: action.payload.rows,
        hedgefunds:
          action.payload.page === 1
            ? [...action.payload.items]
            : [...state.hedgefunds, ...action.payload.items],
      };
    case SEARCH_HEDGEFUND_FAILED:
      return { ...state, loading: false };

    case GET_STRATEGY_INIT:
      return { ...state, loading: true };
    case GET_STRATEGY_SUCCESS:
      return { ...state, companyStrategyData: action.payload, loading: false };
    case GET_STRATEGY_FAILED:
      return { ...state, loading: false };
    case GET_REGION_INIT:
      return { ...state, loading: true };
    case GET_REGION_SUCCESS:
      return { ...state, regions: action.payload, loading: false };
    case GET_REGION_FAILED:
      return { ...state, loading: false };
    case FOLLOW_FUND_INIT:
      return { ...state };
    case FOLLOW_FUND_SUCCESS:
      const newFunds = state.hedgefunds.map((item) => {
        if (item.id === action.payload.fundId) {
          item.followed = action.payload.follow;
          return item;
        } else {
          return item;
        }
      });
      return { ...state, hedgefunds: newFunds };
    case FOLLOW_FUND_FAILED:
      return { ...state };
    case GET_SUBSPECIALTY_INIT:
      return { ...state, loading: true };
    case GET_SUBSPECIALTY_SUCCESS:
      return { ...state, subSpecialties: action.payload, loading: false };
    case GET_SUBSPECIALTY_FAILED:
      return { ...state, loading: false };
    case CREATE_RECOMMENDFUND_INIT:
      return { ...state, rmfundLoading: true };
    case CREATE_RECOMMENDFUND_SUCCESS:
      return { ...state, rmfundLoading: false };
    case CREATE_RECOMMENDFUND_FAILED:
      return { ...state, rmfundLoading: false };
    default:
      return state;
  }
}
